/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModShare: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 13.5C15 14.88 13.88 16 12.5 16C11.12 16 10 14.88 10 13.5C10 13.385 10.01 13.27 10.025 13.16L4.935 10.05C4.53 10.335 4.035 10.5 3.5 10.5C2.12 10.5 1 9.38 1 8C1 6.62 2.12 5.5 3.5 5.5C4.035 5.5 4.53 5.665 4.935 5.95L10.025 2.84C10.01 2.73 10 2.615 10 2.5C10 1.12 11.12 0 12.5 0C13.88 0 15 1.12 15 2.5C15 3.88 13.88 5 12.5 5C11.965 5 11.47 4.835 11.065 4.55L5.975 7.66C5.99 7.77 6 7.885 6 8C6 8.115 5.99 8.23 5.975 8.34L11.065 11.45C11.47 11.165 11.965 11 12.5 11C13.88 11 15 12.12 15 13.5Z'
			/>
		</Svg>
	);
};

export { ModShare };
